// Generated by CoffeeScript 2.7.0
var BASE_FIELDS, BasicMixin, IDENTIFIER_CASE_MAP, IDENTIFIER_CASE_OPTIONS, IMAGE_FIELDS, IMAGE_FIELD_KEYS;

import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import FieldList from 'trunks/vue/admin/components/response_fields/list/fieldable.js';

import ImageField from './image_field.js';

import AttachmentField from '../attachment_field.js';

IDENTIFIER_CASE_MAP = {
  '默认': 'default_identifier',
  '强制大写': 'force_upcase_identifier',
  '强制小写': 'force_downcase_identifier'
};

IDENTIFIER_CASE_OPTIONS = _.map(IDENTIFIER_CASE_MAP, function(_val, key) {
  return {
    id: Skylark.Helpers.Utilities.uuid(),
    isOtherOption: false,
    value: key,
    _destroy: false
  };
});

BASE_FIELDS = [
  {
    id: -1,
    title: 'App ID',
    key: 'appid',
    type: 'Field::TextField',
    validations: ["presence"],
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -2,
    title: 'App Secret',
    key: 'appsecret',
    type: 'Field::TextField',
    validations: ["presence"],
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -3,
    title: 'Identifier alias',
    key: 'identifier_alias',
    type: 'Field::TextField',
    placeholder: '识别码（具体可以询问管理员）',
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -4,
    title: '识别码强制转换',
    key: 'identifier_case',
    description: '一旦修改并保存后立即生效，并且不可逆',
    type: 'Field::RadioButton',
    settings: {
      layout: "select"
    },
    _editing: true,
    options: IDENTIFIER_CASE_OPTIONS
  },
  {
    id: -5,
    title: 'URL',
    key: 'wechat_url',
    validations: ["presence"],
    disabled: true,
    type: 'Field::TextField',
    settings: {
      layout: null
    }
  },
  {
    id: -6,
    title: '微主页',
    key: 'categories_homepage_url',
    validations: ["presence"],
    type: 'Field::TextField',
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -7,
    title: '历史消息推送时间（间隔）',
    key: 'push_interval',
    validations: ["presence"],
    description: '用户主动进入公众号后，在设定的时间内不会收到相同的历史消息推送',
    type: 'Field::Integer',
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -8,
    title: '模板消息ID',
    key: 'template_message_id',
    description: '请填写‘教育>院校’下的‘留言提醒’模版的ID，不使用请留空',
    type: 'Field::TextField',
    settings: {
      layout: null
    },
    _editing: true
  }
];

IMAGE_FIELD_KEYS = ['unread_cover', 'banner_logo', 'logo'];

IMAGE_FIELDS = [
  {
    unread_cover: {
      title: '未读封面',
      helperText: '（建议尺寸360*200）',
      delete: false
    }
  },
  {
    banner_logo: {
      title: 'ICON',
      helperText: '',
      delete: false
    }
  },
  {
    logo: {
      title: 'LOGO',
      helperText: '(新版)',
      delete: true
    }
  }
];

export default BasicMixin = Vue.extend({
  components: {
    'settings-container': SettingsContainer,
    'image-field': ImageField,
    'attachment-field': AttachmentField,
    'field-list': FieldList
  },
  computed: {
    baseAttributefields: function() {
      return _.map(BASE_FIELDS, (item) => {
        return this._createTypeField(item);
      });
    },
    baseAttributeResponse: function() {
      var default_identifier_option;
      default_identifier_option = this.settings.identifier_case ? _.find(IDENTIFIER_CASE_OPTIONS, (option) => {
        return this.settings.identifier_case === IDENTIFIER_CASE_MAP[option.value];
      }) : _.first(IDENTIFIER_CASE_OPTIONS);
      return new Skylark.App.Model.Response({
        id: '_settings_first_attributes_response',
        entries: this._parseEntries()
      });
    }
  },
  methods: {
    refreshToken: function() {
      return Skylark.Bridge.newConfirm({
        title: "刷新token",
        message: "确定要刷新token吗？",
        confirmButtonText: '确定'
      }).$on('ensureClicked', () => {
        return Skylark.Libs.Ajax.patch('/admin/settings/basic/refresh_token', {
          contentType: false,
          responseType: 'json',
          success: (data) => {
            this.settings.token = data.token;
            return Skylark.Bridge.newAlertify('刷新成功', {
              type: 'success'
            });
          }
        });
      });
    },
    imageChanged: function(key, url) {
      return this.settings[key] = url;
    },
    _createTypeField: function(item) {
      return Skylark.App.Model.Field.Base.new(item, void 0, {});
    },
    _transferEntries: function(entries) {
      return _.each(BASE_FIELDS, (field) => {
        var entry;
        switch (field.id) {
          case -4:
            entry = _.find(entries, function(entry) {
              return entry.field_id === field.id && !entry._destroy;
            });
            if (entry) {
              return this.settings.identifier_case = IDENTIFIER_CASE_MAP[entry.value];
            }
            break;
          default:
            entry = _.find(entries, function(entry) {
              return entry.field_id === field.id;
            });
            if (entry) {
              return this.settings[field.key] = entry.value;
            } else {
              return this.settings[field.key] = '';
            }
        }
      });
    },
    _parseEntries: function() {
      return _.map(BASE_FIELDS, (field) => {
        var value;
        value = this.settings[field.key];
        if (field.key === 'identifier_case') {
          value = _.chain(IDENTIFIER_CASE_MAP).pick((option, key) => {
            return option === this.settings[field.key];
          }).keys().first().value();
        }
        return {
          field_id: field.id,
          value: value
        };
      });
    },
    _generateImageFields: function() {
      var fields;
      fields = _.pick(this.settingsData, IMAGE_FIELD_KEYS);
      return _.map(IMAGE_FIELDS, function(value, index) {
        var key;
        key = _.keys(value)[0];
        value[key].url = fields[key];
        value[key].key = key;
        return value[key];
      });
    },
    _generateSettings: function() {
      if (!this.settingsData.identifier_alias) {
        this.settingsData.identifier_alias = '识别码（具体可以询问管理员）';
      }
      return JSON.parse(JSON.stringify(this.settingsData));
    }
  }
});
